import deleteIcon from './delete.svg'
import copyLink from './inviteMember/copyLink.svg'
import emailInviteMember from './inviteMember/emailInviteMember.svg'
import plusIcon from './plusIcon.svg'

export { deleteIcon, plusIcon, copyLink, emailInviteMember }
